import React, { useEffect } from 'react'
import './methodology.css';
import conference from '../../assets/images/conferenceCover.png'
import adhdLife from '../../assets/images/adhdlife.png'
import { Link } from 'react-router-dom';

const Conference = ({ }) => {
  useEffect(() => {
    // Load Whova script
    const script = document.createElement('script');
    script.src = 'https://whova.com/static/frontend/xems/js/whovaWeb.js?eid=gtK7hDmNGwZrEIhf0k7XzPfn%40BmEwJ-zIIKZfN3f3Io%3D&host=https://whova.com';
    script.type = 'text/javascript';
    script.id = 'embeded-web-script';
    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      const existingScript = document.getElementById('embeded-web-script');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant',
  });
    return (
        <div className="container" style={{paddingBottom:"35px"}}>
            <div >
              <h2 style={{marginTop:"15px"}}><strong>Join us for the 2026 Annual Behavioral Health Update: ADHD Throughout the Lifespan!</strong></h2>
              <div className="column60" style={{padding:"0px"}}>
                {/*
                <div className='faqQuestion' style={{marginTop:"35px"}}>
                    <div>
                        <h2 className='subtitle'>
                            <strong>Date</strong>
                        </h2>
                    </div>
                    <div>
                        <div>
                        <p style={{whitespace:"pre-wrap"}}>
                        February 28, 2026 <br/>
                        10:00 am - 4:00 pm
                        </p>
                        </div>
                    </div>
                </div>
                <div className='faqQuestion'>
                    <div>
                    <h2 className='subtitle'>
                            <strong>Location</strong>
                        </h2>
                    </div>
                    <div>
                        <div>
                            <p style={{whitespace:"pre-wrap"}}>
                            Waco Family Medicine<br/>
                            1600 Providence Drive,<br/>
                            Waco, TX 76707
                            </p>
                        </div>
                    </div>
                </div>
              </div>
              <div style={{width:"28%", float:"right"}}>
                <div className='faqQuestion' style={{marginTop:"35px"}}>
                    <img src={conference}/>
                </div>
              </div>
              <div className='faqQuestion'>
                  <div>
                  <h2 className='subtitle'>
                          <strong></strong>
                      </h2>
                  </div>
                  <div>
                    <div>
                        <p style={{whitespace:"pre-wrap"}}>
                        <a style={{whiteSpace:"nowrap", marginLeft:"20%", paddingLeft:"100px", paddingRight:"100px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} href="https://whova.com/portal/registration/wfmbh_202503/" className="btn btn-primary mt-3">Register now</a>
                        </p>
                      </div>
                  </div>
                  
                */}
              </div>
              <div style={{width:"38%", float:"right"}}>
                <div className='faqQuestion' style={{marginTop:"35px"}}>
                    <img src={adhdLife}/>
                </div>
              </div>
              <div className='faqQuestion'>
                  <div>
                  <h2 className='subtitle'>
                    <br/>
                          <strong>description</strong>
                      </h2>
                  </div>
                  <div>
                      <div>
                        <p style={{whitespace:"pre-wrap"}}>
                            This event will feature faculty from Waco Family Medicine–Residency and experts from Massachusetts General Hospital Visiting. Designed for healthcare professionals, this conference will provide in-depth insights into the treatment of ADHD in primary care. 
                        </p>
                        
                        This year's invited speaker from Massachusetts General Hospital Visiting is:<br/><br/>
                        <b>Tim Wilens, MD</b><br/>
                        -Chief, Division of Child and Adolescent Psychiatry<br/>
                        -Co-Director, Center for Addiction Medicine<br/>
                        -Director, Substance Abuse Services in Pediatric Psychopharmacology<br/>
                        
                        <p style={{whitespace:"pre-wrap"}}>
                            Don't miss this unique opportunity to stay at the forefront of behavioral health care. Mark your calendars and check back soon for the most up-to-date details on the conference schedule, registration, and more!
                        </p>
                      </div>
                  </div>
              </div>
            </div>
        </div>
    )
};

export default Conference